import { gql } from '@apollo/client';
import { ContactEmailFragment } from 'graphql/ContactEmail/fragments/ContactEmailFragment';
import { ContactPhoneFragment } from 'graphql/ContactPhone/fragments/ContactPhoneFragment';
import { CurrencyFragment } from 'graphql/Currency/fragments/CurrencyFragment';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
import { LocationFragment } from 'graphql/Location/fragments/LocationFragment';
import { MediaFragment } from 'graphql/Media/fragments/MediaFragment';
import { UserFragment } from 'graphql/User/fragments/UserFragment';
/**
 * @fragment ContactFragment
 * @since 1.0.0
 */
export const ContactFragment = gql `
  fragment ContactFragment on Contact {
    id
    title
    firstname
    lastname
    fullname
    discount
    primary
    manager
    dynamicSalesFormAssign
    dynamicSalesFormNotify
    status
    marketingOptIn
    marketingOptInAt
    marketingOptInSource

    emails {
      ...ContactEmailFragment
    }

    phones {
      ...ContactPhoneFragment
    }

    primaryEmail {
      ...ContactEmailFragment
    }

    primaryPhone {
      ...ContactPhoneFragment
    }

    location {
      ...LocationFragment
    }

    locations {
      ...LocationFragment
    }

    client {
      id
      name
      number
      website
      isEndClient
      createdAt
      updatedAt
      currency {
        ...CurrencyFragment
      }

      locations {
        ...LocationFragment
      }

      primaryLocation {
        ...LocationFragment
      }
    }

    user {
      ...UserFragment
    }

    image {
      ...MediaFragment
    }

    language {
      ...LanguageFragment
    }

    consents {
      id
      purpose
      action
      source
      capturedAt
      textSnapshot
      privacyPolicyUrl
    }
  }

  ${UserFragment}
  ${MediaFragment}
  ${LocationFragment}
  ${ContactEmailFragment}
  ${ContactPhoneFragment}
  ${LanguageFragment}
  ${CurrencyFragment}
`;
